// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._zulp1b66{gap:var(--ds-space-050,4px)}._1bsb1osq{width:100%}\n._1e0c1txw{display:flex}\n._2lx2vrvc{flex-direction:row}\n._4cvr1h6o{align-items:center}", ""]);
// Exports
module.exports = exports;
